<template>
  <div class="analytics-chart-wrap">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  name: "RevenueTimelineChart",
  props: {
    points: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: "line",
      validator: (value) => ["line", "bar"].includes(value),
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    points: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
    mode() {
      this.renderChart();
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
    renderChart() {
      if (!this.$refs.chartCanvas) {
        return;
      }

      this.destroyChart();

      const labels = this.points.map((point) => point.bucket);
      const photos = this.points.map((point) => Number(point.photos || 0));
      const revenue = this.points.map((point) => Number(point.revenue || 0));
      const photosType = this.mode === "bar" ? "bar" : "line";
      const revenueType = this.mode === "bar" ? "bar" : "line";

      this.chartInstance = new Chart(this.$refs.chartCanvas, {
        type: this.mode,
        data: {
          labels,
          datasets: [
            {
              label: "Photos",
              data: photos,
              type: photosType,
              yAxisID: "yPhotos",
              borderColor: "#0d6efd",
              backgroundColor: this.mode === "bar" ? "rgba(13, 110, 253, 0.45)" : "rgba(13, 110, 253, 0.12)",
              borderWidth: 2,
              tension: 0.25,
              pointRadius: this.mode === "line" ? 3 : 0,
            },
            {
              label: "Revenue (GEL)",
              data: revenue,
              type: revenueType,
              yAxisID: "yRevenue",
              borderColor: "#198754",
              backgroundColor: this.mode === "bar" ? "rgba(25, 135, 84, 0.45)" : "rgba(25, 135, 84, 0.12)",
              borderWidth: 2,
              tension: 0.25,
              pointRadius: this.mode === "line" ? 3 : 0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              position: "top",
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const value = Number(context.raw || 0);
                  if (context.dataset.yAxisID === "yRevenue") {
                    return `${context.dataset.label}: ${value.toFixed(2)}`;
                  }

                  return `${context.dataset.label}: ${value}`;
                },
              },
            },
          },
          scales: {
            x: {
              ticks: {
                maxRotation: 45,
                minRotation: 0,
              },
            },
            yPhotos: {
              type: "linear",
              position: "left",
              beginAtZero: true,
              title: {
                display: true,
                text: "Photos",
              },
              ticks: {
                precision: 0,
              },
            },
            yRevenue: {
              type: "linear",
              position: "right",
              beginAtZero: true,
              grid: {
                drawOnChartArea: false,
              },
              title: {
                display: true,
                text: "Revenue (GEL)",
              },
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.analytics-chart-wrap {
  position: relative;
  width: 100%;
  min-height: 320px;
}
</style>
